export default __webpack_public_path__ + "media/images/placeholders/video-0ba607551a3834d06441b5804daacb8f.jpg";